import React from 'react';
import ReadOnlyTemplate from '../components/ReadOnlyTemplate';
import { blockchainData } from '../data/blockchainData';

const Blockchain = () => {
  return (
    <ReadOnlyTemplate
      title="Blockchain Technology"
      sections={blockchainData}
    />
  );
};

export default Blockchain;